<template>
  <SuccessForm
    class="pl-0"
    :title="'verificationStatus.ibtVerification.ibtSuccess.pendingTitle'"
    :desc="'verificationStatus.successVerification.pendingDesc'"
    :lists="lists"
    :primaryButtonLabel="
      $route.query.type === 'withdraw'
        ? 'verificationStatus.ibtVerification.ibtSuccess.primaryButtonLabelWithdraw'
        : 'verificationStatus.ibtVerification.ibtSuccess.primaryButtonLabel'
    "
    :primaryButtonOnClick="onPrimaryButtonClick"
  />
</template>

<script>
import SuccessForm from '@/components/register/registerForms/SuccessForm.vue';
import { RegisterRoutePath } from '@/router/registerRoutes';
import { sensorsTrack } from '@/util/sensorsdata';
import { SENSORS_TRACK } from '@/util/sensorsdata/constant';

export default {
  name: 'IbtSuccess',
  components: { SuccessForm },
  props: { isVerified: { type: Boolean, default: true } },
  created() {
    this.RegisterRoutePath = RegisterRoutePath;
    this.lists = [
      {
        name: '1',
        title: 'verificationStatus.ibtVerification.ibtSuccess.pendingFaqTitle1',
        desc: `verificationStatus.ibtVerification.ibtSuccess.pendingFaqDesc1`
      },
      {
        name: '2',
        title: 'verificationStatus.ibtVerification.ibtSuccess.pendingFaqTitle2',
        desc: `verificationStatus.ibtVerification.ibtSuccess.pendingFaqDesc2`
      },
      {
        name: '3',
        title: 'verificationStatus.ibtVerification.ibtSuccess.pendingFaqTitle3',
        desc: `verificationStatus.ibtVerification.ibtSuccess.pendingFaqDesc3`
      }
    ];
  },
  methods: {
    onPrimaryButtonClick() {
      if (this.$route.query.type === 'withdraw') {
        sensorsTrack(SENSORS_TRACK.EVENT_NAME.OPEN_IDENTITY_PAGE_CLICK, {
        openidentity_level: SENSORS_TRACK.IDENTITY_LEVEL.LV3,
        openidentity_step: SENSORS_TRACK.IDENTITY_STEP.LV3_POA_PASSED,
        button_name: SENSORS_TRACK.BUTTON_NAME.LV3_WITHDRAW
      })
        this.$router.push('/withdrawFunds');
      } else {
        sensorsTrack(SENSORS_TRACK.EVENT_NAME.OPEN_IDENTITY_PAGE_CLICK, {
        openidentity_level: SENSORS_TRACK.IDENTITY_LEVEL.LV3,
        openidentity_step: SENSORS_TRACK.IDENTITY_STEP.LV3_POA_PASSED,
        button_name: SENSORS_TRACK.BUTTON_NAME.LV3_DEPOSIT
      })
        this.$router.push('/depositFunds');
      }
    }
  },
};
</script>
